
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["refundRent_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M725.333 597.333h-256V490.667l-192 192h448z"}}),_c('path',{attrs:{"d":"M896 128H128c-25.6 0-42.667 17.067-42.667 42.667v682.666C85.333 878.933 102.4 896 128 896h768c25.6 0 42.667-17.067 42.667-42.667V170.667C938.667 145.067 921.6 128 896 128zm-42.667 682.667H170.667v-384h682.666v384zm0-469.334H170.667v-128h682.666v128z"}})])
          )
        }
      }
    